import { jsx as _jsx } from "react/jsx-runtime";
import { formatBN } from "@gearbox-protocol/sdk/onchain";
import WithRawValue from "./WithRawValue";
export const TokenAmount = props => {
    const { value, raw, className, flipRawValue } = props;
    const { amount, decimals, symbol } = value;
    const sign = amount < 0n ? "-" : "";
    const abs = amount < 0n ? -amount : amount;
    return (_jsx(WithRawValue, { raw: raw ? BigInt(raw).toString() : undefined, className: className, flipRawValue: flipRawValue, children: _jsx("pre", { children: `${sign}${formatBN(abs, decimals)} ${symbol}` }) }));
};
